import { cn } from '@/lib/utils'
import { useBrand } from '@/shared/providers/brand-provider'
import { useAppContext } from '@/app/shell/app-context'
import { UserMenu } from '@/app/shell/user-menu'
import { ProductSwitcher } from '@/app/shell/product-switcher'
import { AssistantToggle } from '@/modules/assistant'
import { EntitySelector } from '@/modules/hierarchy'
import { NotificationBell } from '@/modules/notifications'

export function TopBar({ impersonating = false }: { impersonating?: boolean }) {
  const { brand } = useBrand()
  const { assistantOpen, setAssistantOpen, assistantToggleRef } = useAppContext()

  return (
    <header
      aria-label="Platform"
      className={cn(
        'bg-sidebar text-sidebar-foreground fixed inset-x-0 z-50 flex h-10 items-center gap-2 px-3',
        impersonating ? 'top-8' : 'top-0',
      )}
    >
      <ProductSwitcher />

      <div className="flex shrink-0 items-center">
        <div
          className="brand-logo h-[22px] [filter:var(--chrome-logo-filter)]"
          role="img"
          aria-label={brand.name}
        />
      </div>

      <EntitySelector />

      <div className="flex-1" />

      <NotificationBell />
      <AssistantToggle ref={assistantToggleRef} open={assistantOpen} onToggle={setAssistantOpen} />
      <UserMenu />
    </header>
  )
}
